import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FormGroup, FormLabel, FormControl, Button } from "react-bootstrap";
import axios from "axios";
import { Prediction } from "../entities/entities";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";

const DynamicForm = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("dynamicForm");
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [prediction, setPrediction] = useState<Prediction>();
  function getPrediction(input: any, explain: boolean, usecase: string) {
    //setTrain(TRAIN.analysis);
    const body = {
      input: input,
      explain: true,
      usecase: usecase,
    };
    props.setPredictionLoading(true);
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "classification/predict", body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        props.setPrediction(response.data);
        //setAnalyse(response.data.analysis);
        props.setPredictionLoading(false);
        //setUploadError(false);
      })
      .catch((error) => {
        props.setPredictionLoading(false);
        //setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  return (
    <>
    <Formik
      initialValues={props.fields.reduce((acc: any, field: any) => {
        if (
          //field.type === "category"
          //&&
          field.options //&&
          // field.options.length > 0
        ) {
          acc[field.name] = field.options[0]; // Initialize with the first option value
        } else {
          acc[field.name] = "";
        }
        return acc;
      }, {})}
      onSubmit={(values) => {
        getPrediction(values, true, "CreditRisk");
      }}
    >
      {({ isSubmitting, resetForm }) => (
        <Form style={{ width: "100%" }}>
          {props.fields.map((field: any, index: any) => (
            <FormGroup key={index}>
              <FormLabel htmlFor={field.name}>{field.name}</FormLabel>
              {field.options ? (
                <Field as="select" className="form-control" name={field.name}>
                  {field.options?.map((option: any, optionIndex: any) => (
                    <option key={optionIndex} value={option}>
                      {option}
                    </option>
                  ))}
                </Field>
              ) : (
                <Field
                  type={field.type}
                  className="form-control"
                  name={field.name}
                />
              )}
              <ErrorMessage
                name={field.name}
                component="div"
                className="text-danger"
              />
            </FormGroup>
          ))}
          <Button
            type="submit"
            variant="primary"
            disabled={false}
            style={{ marginTop: "1rem" }}
          >
            {t("SubmitButton")}
          </Button>
          {/* <Button
            variant="primary"
            disabled={false}
            style={{ marginTop: "1rem" }}
            onClick={() => {
              resetForm();
            }}
          >
            reset
          </Button> */}
        </Form>
      )}
    </Formik>


    </>
  );
};
type Props = {
  fields: any;
  setPrediction: (prediction: Prediction) => void;
  setPredictionLoading: (loading: boolean) => void;
};

export default DynamicForm;
